import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, Home, ArrowLeft, Satellite } from 'lucide-react';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        <div className="text-center">
          <div className="mb-8 relative">
            <div className="inline-flex items-center justify-center">
              <div className="relative">
                <Satellite className="w-24 h-24 text-gray-300 animate-pulse" />
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-gradient-to-r from-blue-600 to-green-600 rounded-full flex items-center justify-center">
                  <Search className="w-5 h-5 text-white" />
                </div>
              </div>
            </div>
          </div>

          <h1 className="text-6xl md:text-8xl font-bold mb-4">
            <span className="bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent">
              404
            </span>
          </h1>

          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            Page Not Found
          </h2>

          <p className="text-lg text-gray-600 mb-8 max-w-md mx-auto">
            The page you're looking for seems to have drifted out of orbit. Let's get you back on track.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto mb-12">
            <button
              onClick={handleGoHome}
              className="flex-1 flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-green-600 text-white rounded-lg font-semibold hover:from-blue-700 hover:to-green-700 transition-all shadow-lg hover:shadow-xl"
            >
              <Home className="w-5 h-5" />
              Go Home
            </button>

            <button
              onClick={handleGoBack}
              className="flex-1 flex items-center justify-center gap-2 px-6 py-3 bg-white text-gray-700 rounded-lg font-semibold border-2 border-gray-300 hover:border-gray-400 hover:bg-gray-50 transition-all"
            >
              <ArrowLeft className="w-5 h-5" />
              Go Back
            </button>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8 max-w-md mx-auto">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Looking for something specific?
            </h3>
            <div className="space-y-3 text-left">
              <a
                href="/"
                className="block p-3 rounded-lg border border-gray-200 hover:border-blue-400 hover:bg-blue-50 transition-all group"
              >
                <div className="font-medium text-gray-900 group-hover:text-blue-600">
                  Browse SIM Cards
                </div>
                <div className="text-sm text-gray-600">
                  Explore our satellite communication products
                </div>
              </a>
              <a
                href="/customer/login"
                className="block p-3 rounded-lg border border-gray-200 hover:border-green-400 hover:bg-green-50 transition-all group"
              >
                <div className="font-medium text-gray-900 group-hover:text-green-600">
                  Customer Portal
                </div>
                <div className="text-sm text-gray-600">
                  Manage your SIM cards and account
                </div>
              </a>
              <a
                href="/admin"
                className="block p-3 rounded-lg border border-gray-200 hover:border-purple-400 hover:bg-purple-50 transition-all group"
              >
                <div className="font-medium text-gray-900 group-hover:text-purple-600">
                  Admin Panel
                </div>
                <div className="text-sm text-gray-600">
                  Access administrative functions
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
